import { CPF_MASK, CNPJ_MASK } from "src/utils/constants"

const applyMask = (value, mask) => {
    let result = ""
    let index = 0

    for (let i = 0; i < mask.length && index < value.length; i++) {
        if (mask[i] === "9") {
            result += value[index]
            index++
        } else {
            result += mask[i]
        }
    }

    return result
}

export const formatCpfCnpj = (value) => {
    if (!value) return ""

    const onlyNumbers = value.toString().replace(/\D/g, "")

    if (onlyNumbers.length === 11) {
        return applyMask(onlyNumbers, CPF_MASK)
    }

    if (onlyNumbers.length === 14) {
        return applyMask(onlyNumbers, CNPJ_MASK)
    }

    return value
}
